import core from './core';

export default {
  create({ identity_type, birthday, nationality, no, sim_type, vendor_id }) {
    return core.post('/queries', {
      identity_type, birthday, nationality, no, sim_type, vendor_id,
    });
  },

  get({ vendor_id, search, page, per_page, sort, direction }) {
    return core.get('queries', {
      params: {
        vendor_id, search, page, per_page, sort, direction
      }
    });
  },

  batch({ file, vendor_id, identity_type, }) {
    return core.postFormData('/queries/batch', {
      file, vendor_id, identity_type,
    });
  },
}
